import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "extent-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  id: "draw-map",
  style: {"height":"400px","width":"100%"}
}, null, -1)
const _hoisted_3 = { class: "dialog-footer" }

import useBoundaryMap from '@/composables/useBoundaryMap';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExtentBoundary',
  setup(__props) {

const {
  minX,
  minY,
  maxX,
  maxY,
  extentVisible,
  dialogVisible,
  initDrawMap,
  startDraw,
  refreshExtentByMainMap,
  showDrawer,
  confirmDrawer,
  refreshMainMapByExtent,
} = useBoundaryMap();

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createBlock(_component_el_popover, {
    placement: "top",
    trigger: "click",
    modelValue: _unref(extentVisible),
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(extentVisible) ? (extentVisible).value = $event : null)),
    width: "400",
    "popper-style": { zIndex: 4001 },
    onShow: _unref(refreshExtentByMainMap)
  }, {
    reference: _withCtx(() => [
      _createVNode(_component_el_button, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('ExtentBoundary.title')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_row, { justify: "center" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('ExtentBoundary.maxY')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(maxY),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(maxY) ? (maxY).value = $event : null)),
                  placeholder: _ctx.$t('ExtentBoundary.maxY'),
                  size: "small",
                  style: {"width":"100px"},
                  onChange: _unref(refreshMainMapByExtent)
                }, null, 8, ["modelValue", "placeholder", "onChange"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { justify: "center" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('ExtentBoundary.minX'),
              style: {"margin-right":"15px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(minX),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(minX) ? (minX).value = $event : null)),
                  placeholder: _ctx.$t('ExtentBoundary.minX'),
                  size: "small",
                  style: {"width":"100px"},
                  onChange: _unref(refreshMainMapByExtent)
                }, null, 8, ["modelValue", "placeholder", "onChange"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('ExtentBoundary.maxX')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(maxX),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(maxX) ? (maxX).value = $event : null)),
                  placeholder: _ctx.$t('ExtentBoundary.maxX'),
                  size: "small",
                  style: {"width":"100px"},
                  onChange: _unref(refreshMainMapByExtent)
                }, null, 8, ["modelValue", "placeholder", "onChange"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { justify: "center" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('ExtentBoundary.minY')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(minY),
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(minY) ? (minY).value = $event : null)),
                  placeholder: _ctx.$t('ExtentBoundary.minY'),
                  size: "small",
                  style: {"width":"100px"},
                  onChange: _unref(refreshMainMapByExtent)
                }, null, 8, ["modelValue", "placeholder", "onChange"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { justify: "end" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: _unref(showDrawer)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('ExtentBoundary.frommap')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_dialog, {
              title: "",
              class: "draw-boundary",
              modelValue: _unref(dialogVisible),
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(dialogVisible) ? (dialogVisible).value = $event : null)),
              onOpened: _unref(initDrawMap),
              "destroy-on-close": true,
              "append-to-body": true
            }, {
              title: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  plain: "",
                  onClick: _unref(startDraw)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('ExtentBoundary.drawboundary')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_button, {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (dialogVisible.value = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('ExtentBoundary.cancel')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _unref(confirmDrawer)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('ExtentBoundary.confirm')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["modelValue", "onOpened"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onShow"]))
}
}

})